<script>
  export let idUnico = 'teste';
  export let semlegenda = false;
  export let content;
  import { onMount } from 'svelte';

  let lines;
  let tabs;
  let tab = [];

  // idUnico = 'tabs-1';

  onMount(() => {
    j$(`#${idUnico} .tabs`).addClass('nav nav-tabs');
    j$(`#${idUnico} .content`).addClass('tab-content');
    j$.each(j$(`#${idUnico} .nav-tabs > a`), (i, element) => {
      j$(element).attr({
        class: 'nav-link',
        id: `${idUnico}-link-${i}`,
        href: `#${idUnico}-tab-${i}`,
        role: 'tab',
        'data-toggle': 'tab',
        'aria-controls': `#${idUnico}-tab-${i}`,
      });
      // if (i === 0) {
      //   j$(element).addClass('active');
      // }
    });

    j$.each(j$(`#${idUnico} .tab-content > div`), (i, element) => {
      j$(element).attr({
        class: 'tab-pane fade',
        id: `${idUnico}-tab-${i}`,
        role: 'tabpanel',
        'aria-labelledby': `#${idUnico}-link-${i}`,
      });
      // if (i === 0) {
      //   j$(element).addClass('show active');
      // }
    });

    let height = set_same_height_collection(j$(`#${idUnico}`).find('.tab-pane'));

    j$(`#${idUnico} .tab-content`).css('height', height + 120);
  });

  tabs = content.split(';;');

  tabs.forEach((element, index) => {
    if (element.trim() != '') tab[index] = element.split('::');
  });
</script>

<div class="container" id={idUnico}>
  <div class="tabs nav nav-tabs">
    {#each tab as t, index}
      <a
        id={'tabs-1' + '-link-' + index}
        class="nav-link {index == 0 ? 'active' : ''}"
        target="_blank"
        href={'#tabs-1' + '-tab-' + index}
        role="tab"
        data-toggle="tab"
      >
        {t[0]}
      </a>
    {/each}
  </div>

  <div class="content tab-content">
    {#each tab as t, index}
      <div
        id={'tabs-1' + '-tab-' + index}
        class="tab-pane {index == 0 ? 'show active' : ''}"
        role="tabpanel"
      >
        {t[1]}
      </div>
    {/each}
  </div>

  <div class="justify-content-center">
    {#if !semlegenda}
      <div class="mt-2">
        <div class="legenda">
          <slot name="legenda" />
        </div>
        <div class="credito">
          <slot name="credito" />
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  .container :global(.nav-tabs) {
    position: relative;
    all: unset;
    display: grid;
    z-index: 9;
    grid-auto-flow: column;
    /* grid-auto-columns: minmax(0, 1fr); */
    text-align: center;
    /* border: 0px solid transparent; */
    /* align-items: center; */
    /* grid-auto-rows: 1fr; */
  }

  .container :global(.nav-link) {
    height: 100%;
    background: var(--COR_MODULO_FORTE);
    border-radius: 0 0 0 0;
    /* padding: 15px 10px; */
    font-size: 18px;
    padding: 15px 5px;
    margin-right: 1px;
    /* margin-bottom: 1px; */
    color: #fff;
    font-weight: 400;
    transition: all 200ms ease;
    display: flex;
    justify-content: center;
    align-items: center;
    /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1); */
    border: 0;
    border-bottom: 1px solid white;
    word-break: normal;
    font-weight: 600;
  }
  .container :global(.nav-link:last-child) {
    margin-right: 0;
    border-radius: 0 15px 0 0;
  }
  .container :global(.nav-link:first-child) {
    border-radius: 15px 0 0 0;
  }
  .container :global(.nav-link) {
    color: var(--COR_FONTE);
    background: var(--VERDE_CLARO_60);
    opacity: 0.8;
    /* height: 100%; */
  }
  .container :global(.nav-link:hover) {
    color: var(--COR_FONTE);
    background: var(--VERDE_CLARO_60);
    opacity: 1;
    /* border: 1px solid transparent; */
  }
  .container :global(.nav-link.active) {
    color: #fff;
    background: var(--VERDE_CLARO);
    /* margin-bottom: 0; */
    cursor: default;
    opacity: 1;
    border-bottom: 1px solid transparent;
  }

  .container :global(.tab-content:has(.active)) {
    background: var(--VERDE_CLARO);
  }
  .container :global(.tab-content) {
    position: relative;
    background: var(--VERDE_CLARO_60);
    color: #fff;
    /* min-height: 150px; */
    padding: 40px 40px;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1); */
    z-index: 9;
  }

  .legenda,
  .credito {
    text-align: center;
    color: #504f51;
    font-weight: 400;
  }

  .legenda {
    font-size: 1rem;
  }

  .credito {
    font-size: 0.85rem;
  }

  .container {
    /* max-width: 44em !important; */
  }

  @media (max-width: 767px) {
    .container :global(.nav-tabs) {
      grid-auto-flow: row;
      row-gap: 5px;
    }
    .container :global(.nav-tabs > .nav-link) {
      width: 100%;
      margin: 0;
      justify-content: center;
    }
    .container :global(.nav-link:first-child) {
      border-radius: 10px;
    }
    .container :global(.nav-link:last-child) {
      border-radius: 10px;
    }
    .container :global(.nav-link) {
      border-radius: 10px;
    }
    .container :global(.tab-content) {
      margin-top: 5px;
      border-radius: 10px;
    }
  }
</style>
